module.exports = {"ORTPAD-1":"Sesja zakończona. Użytkownik został wylogowany.","DEFAULT":"Nieznany błąd. Aplikacje została zrestartowana."}